export default {"src":"/_next/static/media/logo.9b23f77f.svg","height":165,"width":400,"blurWidth":0,"blurHeight":0};